// Products portfolio strip, used on the homepage.
import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Building2, Search, FileSpreadsheet, ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  { Icon: Building2, t: "CoSec App", d: "AI-powered UK company secretarial software, entity management, board work, filings, registers.", href: "/cosecapp", flag: "FLAGSHIP" },
  { Icon: Search, t: "CoSearch", d: "UK company intelligence, 5m companies, officers, PSCs, group structures, sector benchmarks.", href: "/cosearch", flag: "NEW" },
  { Icon: FileSpreadsheet, t: "CoForm", d: "Form your UK company in under an hour, authorised Companies House agent.", href: "/coform" },
  { Icon: ShieldCheck, t: "CoVerify", d: "Connected ID verification, biometric document + liveness + AML, ECCTA ready.", href: "/coverify", flag: "LIVE" },
];

export default function ProductsPortfolio() {
  return (
    <section id="products" className="py-20 md:py-28 bg-white">
      <div className="container-cv">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div className="max-w-2xl">
            <span className="section-eyebrow">Product portfolio</span>
            <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight leading-[1.08]">
              The complete{" "}
              <span className="text-accent">CoSec Global suite.</span>
            </h2>
            <p className="mt-4 text-base md:text-lg text-muted-foreground">
              Four connected products covering entity management, identity verification, company intelligence and company formation, designed to work together.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5" data-testid="products-portfolio">
          {PRODUCTS.map((p) => (
            <Link
              key={p.t}
              to={p.href}
              data-testid={`product-${p.t.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[hsl(207_74%_21%)] p-6 hover:-translate-y-1 hover:border-accent/60 hover:shadow-[0_20px_50px_-18px_rgba(14,58,95,0.5)] transition-all"
            >
              {/* Ambient highlights */}
              <span aria-hidden className="pointer-events-none absolute -top-20 -right-20 h-48 w-48 rounded-full bg-accent/20 blur-3xl" />
              <span aria-hidden className="pointer-events-none absolute -bottom-24 -left-12 h-44 w-44 rounded-full bg-[hsl(207_74%_50%)]/25 blur-3xl" />

              {p.flag && (
                <span className={`absolute top-4 right-4 z-10 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                  p.flag === "NEW" ? "bg-accent text-primary" :
                  p.flag === "LIVE" ? "bg-accent/20 text-accent border border-accent/40" :
                  "bg-accent/15 text-accent border border-accent/30"
                }`}>{p.flag}</span>
              )}
              <div className="relative h-12 w-12 grid place-items-center rounded-xl bg-white/10 text-accent ring-1 ring-white/15 group-hover:bg-accent group-hover:text-primary transition-colors">
                <p.Icon className="h-6 w-6" />
              </div>
              <h3 className="relative mt-5 font-display text-xl font-bold text-white tracking-tight">{p.t}</h3>
              <p className="relative mt-2 text-sm text-white/70 leading-relaxed">{p.d}</p>
              <div className="relative mt-5 inline-flex items-center gap-1 text-sm font-bold text-accent group-hover:gap-2 transition-all">
                Explore <ArrowUpRight className="h-4 w-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
